import {useI18n} from 'i18n/I18nContext'
import EventPage from 'organization/Event/EventPage'
import BreadcrumMenu from 'organization/theme/Breadcrum'
import React, {useState} from 'react'
import {Product} from 'organization/Event/Products/EventProductsProvider'
import {UpdateProductModal} from 'organization/Event/Products/UpdateProductModal'
import {EventFaqHelp} from 'organization/Event/Help/FAQ'
import {ProductsListing} from 'organization/Event/Products/ProductsListing'

export const Products = () => {
  const {t} = useI18n()
  const [showModal, setShowModal] = useState<boolean>(false)
  const [editingProduct, setEditingProduct] = useState<Product | null>(null)
  const toggleShowModal = () => {
    setShowModal((curr: boolean) => !curr)
  }

  const editProduct = (product: Product) => {
    setEditingProduct(product)
  }

  const closeEdit = () => {
    if (editingProduct) {
      setEditingProduct(null)
    } else {
      toggleShowModal()
    }
  }

  return (
    <EventPage
      modals={
        <>
          <UpdateProductModal
            key={editingProduct?.id ?? 'new-product'}
            show={!!editingProduct || showModal}
            product={editingProduct}
            onClose={closeEdit}
          />
        </>
      }
    >
      <>
        <div className="row pl-30 pb-30 pr-30">
          <BreadcrumMenu
            title={t('org.sidebar.products')}
            helpInfo={<EventFaqHelp faqKey="productsPage" />}
          />

          <ProductsListing
            editProduct={editProduct}
            toggleShowModal={toggleShowModal}
          />
          {/* <EventProductPurchasesProvider>
            <ProductsPurchases />
          </EventProductPurchasesProvider> */}
        </div>
      </>
    </EventPage>
  )
}
